import storage from "../../utils/storage";
import objectKeysMatch from "../../utils/objectKeysMatch";

export const emptyState = {
  tagIds: [],
  currentArticleId: null,
  articleIds: []
};

const typePrefix = "articles/filter/";
const SET_FILTERED = `${typePrefix}SET_FILTERED`;
const CLEAR_FILTERED = `${typePrefix}CLEAR_FILTERED`;
const SET_SELECTED = `${typePrefix}SET_SELECTED`;
const CLEAR_SELECTED = `${typePrefix}CLEAR_SELECTED`;
const SET_ARTICLES = `${typePrefix}SET_ARTICLES`;
const storageName = typePrefix.replace("/", "");

// Helpers

/**
 * Rehydrate the state from storage.
 * @return {object} Previously saved state or default state
 */
export const rehydrate = () => {
  const saved = storage.getItem(storageName);
  let hydrated = emptyState;
  if (typeof saved === "string" && saved !== "undefined") {
    try {
      hydrated = JSON.parse(saved);
    } catch (e) {
      hydrated = emptyState;
      // eslint-disable-next-line no-console
      console.log("Could not rehydrate from storage", e);
    }
  }
  // guard against unusual state coming back from storage
  if (!objectKeysMatch(emptyState, hydrated)) return emptyState;
  return hydrated;
};

// Selectors

export const getFilterState = state => state.articles.filter;
export const getFilterTags = state => state.articles.filter.tagIds;
export const getFilterArticles = state => state.articles.filter.articleIds;
export const getSelectedId = state => state.articles.filter.currentArticleId;

// Action creators

/**
 *
 * @param {string} tagIds the ids of tags to filter on
 * @return {function} thunk action creator
 */
export const setFiltered = tagIds => (dispatch, getState) => {
  dispatch({
    type: SET_FILTERED,
    tagIds
  });
  const serialised = JSON.stringify(getFilterState(getState()));
  storage.setItem(storageName, serialised);
};

/**
 *
 * @param {string} articleId the article Id to be marked as selected
 * @return {function} thunk action creator
 */
export const setSelectedId = articleId => (dispatch, getState) => {
  dispatch({
    type: SET_SELECTED,
    articleId
  });
  const serialised = JSON.stringify(getFilterState(getState()));
  storage.setItem(storageName, serialised);
};

/**
 *
 * @param {string} articleId the article Id to be marked as selected
 * @return {function} thunk action creator
 */
export const setArticleIds = articleIds => (dispatch, getState) => {
  dispatch({
    type: SET_ARTICLES,
    articleIds
  });
  const serialised = JSON.stringify(getFilterArticles(getState()));
  storage.setItem(storageName, serialised);
};

// Reducer

export function filterReducer(state = rehydrate(), action = {}) {
  switch (action.type) {
    case SET_FILTERED:
      return { ...state, tagIds: action.tagIds };
    case CLEAR_FILTERED:
      return { ...state, tagIds: [] };
    case SET_SELECTED:
      return { ...state, currentArticleId: action.articleId };
    case CLEAR_SELECTED:
      return { ...state, currentArticleId: null };
    case SET_ARTICLES:
      return { ...state, articleIds: action.articleIds };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/state/articles/filter.js